"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestTransport = exports.WorkRequestUpdateInput = exports.WorkRequestTransport = exports.WorkRequestType = exports.OrderRequestUpdateInput = exports.OrderRequestTransport = exports.OrderRequestStatus = exports.RequestType = void 0;
const typebox_1 = require("@sinclair/typebox");
const alliance_order_transport_1 = require("./alliance-order-transport");
const order_transport_1 = require("./order-transport");
exports.RequestType = typebox_1.Type.Union([typebox_1.Type.Literal('NEW_ORDER'), typebox_1.Type.Literal('WORK_REQUEST')]);
exports.OrderRequestStatus = typebox_1.Type.Union([
    typebox_1.Type.Literal('PENDING'),
    typebox_1.Type.Literal('APPROVED'),
    typebox_1.Type.Literal('REJECTED'),
    typebox_1.Type.Literal('CANCELLED'),
]);
exports.OrderRequestTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    status: exports.OrderRequestStatus,
    haulerID: typebox_1.Type.String(),
    allianceOrderID: typebox_1.Type.String(),
    haulerOrderID: typebox_1.Type.Optional(typebox_1.Type.String()),
    switchFromOrderID: typebox_1.Type.Optional(typebox_1.Type.String()),
    switchFromOrder: typebox_1.Type.Optional(order_transport_1.OrderTransport),
    orderData: typebox_1.Type.Pick(alliance_order_transport_1.AllianceOrderTransport, [
        'serviceLocation',
        'material',
        'expectedSize',
        'expectedDeliveryDate',
        'poNumber',
    ]),
    expires: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.OrderRequestUpdateInput = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.OrderRequestTransport, ['status']),
    typebox_1.Type.Object({
        switchFromOverride: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        disposalSite: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        switchType: typebox_1.Type.Optional(typebox_1.Type.String()),
    }),
    /*   Type.Object({
      idForAlliance: Type.String(),
    }), */
]);
exports.WorkRequestType = typebox_1.Type.Union([typebox_1.Type.Literal('FINAL_REMOVAL'), typebox_1.Type.Literal('RELOCATION')]);
exports.WorkRequestTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    status: exports.OrderRequestStatus,
    type: exports.WorkRequestType,
    haulerID: typebox_1.Type.String(),
    sourgumOrderID: typebox_1.Type.String(),
    waysteOrderID: typebox_1.Type.String(),
    waysteOrder: order_transport_1.OrderTransport,
    expires: typebox_1.Type.Optional(typebox_1.Type.String()),
    actionDate: typebox_1.Type.String({ format: 'date' }),
    acceptedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.WorkRequestUpdateInput = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.WorkRequestTransport, ['status']),
    typebox_1.Type.Object({
        dateOverride: typebox_1.Type.Optional(typebox_1.Type.String()),
        disposalSite: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
exports.RequestTransport = typebox_1.Type.Union([
    typebox_1.Type.Object({
        type: typebox_1.Type.Literal('NEW_ORDER'),
        request: exports.OrderRequestTransport,
    }),
    typebox_1.Type.Object({
        type: typebox_1.Type.Literal('WORK_REQUEST'),
        request: exports.WorkRequestTransport,
    }),
]);
//# sourceMappingURL=order-request-transport.js.map